import { type FC, useCallback } from 'react';

import { httpGetSearchSaved } from '@iconik-io/iconik-api/src/services/search';

import { useAppDispatch } from '../../../../store/react_redux_typed';
import { prepareQueryParameter } from '../../../../utils/search_utils/search_utils';
import type { SelectOption } from '../../../select_field/types';
import {
  type LoadOptionsResult,
  resolveRemoteResponse,
} from '../../../select_field/utils';
import SelectFieldWrapper, {
  type SelectFieldWrapperProps,
} from '../select/select';

export const SelectSavedSearchesFieldWrapper: FC<SelectFieldWrapperProps> = (
  props,
) => {
  const dispatch = useAppDispatch();

  const handleLoadOptions = useCallback(
    (query: string): Promise<LoadOptionsResult> =>
      dispatch(
        httpGetSearchSaved({
          query: prepareQueryParameter(query),
          per_page: 20,
        }),
      ).then(
        resolveRemoteResponse((response) =>
          response.body.objects.map((object) => ({
            value: object.id,
            label: object.name,
          })),
        ),
      ),
    [],
  );

  const handleLoadSelectedOptions = useCallback(
    (ids: string[]): Promise<SelectOption[]> =>
      dispatch(httpGetSearchSaved({ ids: ids.join(','), per_page: 20 })).then(
        (response) =>
          response.body.objects.map((object) => ({
            value: object.id,
            label: object.name,
          })),
      ),
    [],
  );

  return (
    <SelectFieldWrapper
      {...props}
      preloadOptions
      loadOptions={handleLoadOptions}
      loadSelectedOptions={handleLoadSelectedOptions}
    />
  );
};

export default SelectSavedSearchesFieldWrapper;
